module.exports = __webpack_public_path__ + "static/media/wizardRedEyes2.fefc5863.gif";